var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('amplify-authenticator',[_c('amplify-sign-up',{attrs:{"slot":"sign-up","username-alias":"email"},domProps:{"formFields":[
            { type: 'email'},
            { type: 'password' } ]},slot:"sign-up"}),_c('amplify-sign-in',{attrs:{"slot":"sign-in","username-alias":"email"},slot:"sign-in"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }